module.exports = __webpack_public_path__ + "static/media/kudos_disable.a3c365b2.svg";